import { apiClient } from '@/lib/apiClient';

interface ArtifactFile {
  url: string;
  filename: string;
}

const cache = new Map<string, ArtifactFile>();

export const artifactService = {
  getFileUrl: async (fileId: string, token: string): Promise<ArtifactFile> => {
    if (cache.has(fileId)) return cache.get(fileId)!;
    const result = await apiClient<ArtifactFile>(`/artifacts/files/${fileId}`, {
      headers: { Authorization: `Bearer ${token}` },
      skipAuthErrorHandling: true,
    });
    cache.set(fileId, result);
    return result;
  },
};
